<template>
    <div class="report">
        <q-scroll-area ref="scrollAreaRef" visible style="height: 100%">
            <div class="bg_color_gray_100">
                <div class="top__info b1">
                    <div class="top__info__wrap">
                        <div>
                            <div>
                                <!-- 학교명_학년 -->
                                <!-- <div class="b1 color_gray_800">{{ isMember ? globalStore.userInfo.schoolName + ' ' + getStringUserGrade : nonMemberSchoolGrade}}</div> -->
                                <div class="b1 color_gray_800">{{ comSchoolAndGrade }}</div>
                                <div class="report__title" style="margin-top: 20px">
                                    <b>
                                        <!-- 유저이름_닉네임 -->
                                        <!-- {{ isMember ? globalStore.userInfo.studentName : gStore.evalData.nick }}님의<br /> -->
                                        {{ comUserName }}님의<br />
                                        KReaD 지수는
                                        <span class="color_primary bold"> {{ summaryData?.kreadScore }}</span>
                                        <!-- 으로 <br /> -->
                                        <!-- <span class="color_primary bold"> {{ getKreadGrade(summaryData?.kreadScore) }} 수준</span> -->
                                        입니다.
                                    </b>
                                </div>
                            </div>
                            <div class="report__calendar">
                                <div class="flex align-center">
                                    <q-icon name="img:/assets/images/icon/ico_report_calender.svg" style="width: 2.1vw; height: 2.1vw; margin-right: 1vmin" />
                                    <span>{{ summaryData?.completeDate }}</span>
                                </div>
                                <div class="flex align-center mg_top_24" style="margin-top: 10px">
                                    <q-icon name="img:/assets/images/icon/ico_report_code.svg" style="width: 2.1vw; height: 2.1vw; margin-right: 1vmin" />
                                    <span>응시 코드 : {{ summaryData?.participantCode }}</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="chart__wrap">
                                <div class="chart__item">
                                    <div class="chart__area">
                                        <GaugeChart v-if="summaryData?.level" :chartData="summaryData?.level" :endData="3" unit="레벨" :label="summaryData?.level" />
                                        <!-- <GaugeChart v-if="summaryData?.level" :chartData="((2 - 1) * 2) + (49 !== 1 ? 1 : 0)" :endData="5"
                      unit="레벨" :label="summaryData?.level" /> -->
                                        <div class="mg_top_24">
                                            <LevelLineChart v-if="summaryData?.lesson" :value="summaryData?.lesson" color="#18b73f" height="1.66" text="레슨" :max="96" />
                                        </div>
                                    </div>
                                    <div class="chart__summary">
                                        <div>
                                            <div class="b1 line_height_45">학습 출발점</div>
                                            <div class="h3 color_black bold" style="display: flex; flex-direction: row; align-items: center">
                                                <span class="color_primary bold">{{ summaryData?.level }}</span
                                                >레벨
                                                <div style="width: 0.2vw; height: 2vh; background: #e0e0e0; margin-left: 0.6vw; margin-right: 0.6vw" />
                                                <span class="color_primary bold">{{ summaryData?.lesson }}</span
                                                >레슨
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pd_lr_230">
                <div class="title mg_top_46" style="margin-top: 3.4vmin">진단평가 결과</div>
                <div>
                    <div class="row justify-between b3">
                        <div class="summary_box" style="padding-right: 10px">
                            <div>
                                <div class="medium">
                                    독해력<Help class="question-mark">
                                        <div class="help__content">지문을 적정 시간에 정확하게 읽고, 이해하여 문제를 해결할 수 있는 능력</div>
                                    </Help>
                                </div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">{{ summaryData?.accuracyRate }}</span
                                    >/100 <span class="b2 bold" style="font-size: 2vmin">%</span>
                                </div>
                            </div>
                            <div>
                                <q-icon name="img:/assets/images/icon/img_archer.png" size="12vmin" />
                            </div>
                        </div>
                        <div class="summary_box">
                            <div>
                                <div class="medium">맞힌 문항수</div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">{{ summaryData?.correctCount }}</span
                                    >/36 <span class="b2 bold" style="font-size: 2vmin">문항</span>
                                </div>
                            </div>
                            <div>
                                <q-icon name="img:/assets/images/icon/ico_Good.png" size="10vmin" />
                            </div>
                        </div>
                        <div class="summary_box">
                            <div>
                                <div class="medium">소요 시간</div>
                                <div class="h1 line_height_66 bold">
                                    <span class="color_primary bold">
                                        <!-- {{ summaryData?.elapsedTime }} -->
                                        <!-- {{ summaryData?.elapsedHour !== 0 ? summaryData?.elapsedHour : '' }}
                    <span v-if="summaryData?.elapsedHour !== 0" class="b2 bold" style="font-size: 2vmin;">시간</span>
                    {{ summaryData?.elapsedMinute !== 0 ? summaryData?.elapsedMinute : '' }}
                    <span v-if="summaryData?.elapsedMinute !== 0" class="b2 bold" style="font-size: 2vmin;">분</span>
                    {{ summaryData?.elapsedSecond !== 0 ? summaryData?.elapsedSecond : '' }}
                    <span v-if="summaryData?.elapsedSecond !== 0" class="b2 bold" style="font-size: 2vmin;">초</span> -->

                                        <template v-if="summaryData?.elapsedHour !== 0"> {{ summaryData?.elapsedHour }}<span class="b2 bold" style="font-size: 2vmin">시간 </span> </template>
                                        <template v-if="summaryData?.elapsedMinute !== 0"> {{ summaryData?.elapsedMinute }}<span class="b2 bold" style="font-size: 2vmin">분 </span> </template>
                                        <template v-if="summaryData?.elapsedSecond !== 0"> {{ summaryData?.elapsedSecond }}<span class="b2 bold" style="font-size: 2vmin">초</span> </template> </span
                                    >/60
                                    <span class="b2 bold" style="font-size: 2vmin">분</span>
                                </div>
                            </div>
                            <div>
                                <q-icon name="img:/assets/images/icon/ico_clock_green.png" size="10vmin" />
                            </div>
                        </div>
                    </div>
                    <div class="mg_top_32 final__comment">
                        <p class="evalReportText20 bold">{{ comments?.commentDiagnosticResult }}</p>
                    </div>
                </div>
            </div>
            <div class="hr" />
            <div class="pd_lr_230 mg_top_58">
                <div style="display: inline-flex; justify-content: space-between; width: 100%">
                    <div class="title">
                        나의 KReaD<Help class="question-mark">
                            <div class="help__content">KReaD는 학습자가 능숙하게 읽을 수 있는 지문의 수준을 객관적 수치로 나타낸 것입니다. 숫자가 클수록 학습자의 독해 수준이 높음을 의미하며, 연령별 평균 KReaD는 연령*100으로 계산할 수 있습니다.</div>
                        </Help>
                    </div>
                    <div class="kread">
                        <img src="@/assets/images/main/kread_green.svg" />
                        <div class="score">
                            {{ summaryData?.kreadScore }}
                        </div>
                    </div>
                </div>
                <div class="final__comment mg_top_20 mg_bottom_36">
                    <p class="evalReportText20">{{ comments?.commentMyKread }}</p>
                </div>

                <div class="kread_area">
                    <div class="row">
                        <div class="b3 pd_right_24 bold col2" style="display: inline-flex; align-items: flex-end; padding-bottom: 30px">나의 크리드</div>
                        <div class="col">
                            <KreadChart v-if="summaryData" :value="summaryData?.kreadScore" :height="2" />
                        </div>
                    </div>
                </div>

                <div class="start_title">
                    <div class="title">학습 출발점</div>
                    <div class="level">{{ summaryData?.level }}레벨 {{ summaryData?.lesson }}레슨</div>
                </div>
                <div class="final__comment mg_bottom_40" style="margin-top: 0.5vmin">
                    <p class="evalReportText20">{{ comments?.commentStartPoint }}</p>
                </div>
                <div class="start_area">
                    <div class="row">
                        <div class="b3 pd_right_24 bold col2" style="display: inline-flex; align-items: center">나의 레벨</div>
                        <div class="col">
                            <LevelLineChart v-if="summaryData?.level" :value="summaryData?.level" height="3.33" color="#18b73f" />
                        </div>
                    </div>
                    <div class="row mg_top_72">
                        <div class="b3 pd_right_24 bold col2" style="display: inline-flex; align-items: center; margin-top: 20px">나의 레슨</div>
                        <div class="col">
                            <LessonChart v-if="summaryData?.lesson" :lesson="summaryData?.lesson" height="3.33" />
                        </div>
                    </div>
                </div>
                <div class="title">학습 상세분석</div>
                <div class="title__sub">⦁ 갈래/주제별 독해력 분석</div>
                <div class="final__comment mg_bottom_40" style="margin-top: 1vmin; padding-left: 1.8vw">
                    <p class="evalReportText20">{{ comments?.commentTopic }}</p>
                </div>
                <div class="radar" style="width: 100%; display: inline-flex; justify-content: space-between">
                    <div class="radar__box">
                        <div class="radar__box__top">문학</div>
                        <div class="radar__box__content">
                            <RadarChart v-if="lTopicChartData" :chart-data="lTopicChartData" />
                        </div>
                    </div>
                    <div class="radar__box">
                        <div class="radar__box__top">비문학</div>
                        <div class="radar__box__content">
                            <RadarChart v-if="nTopicChartData" :chart-data="nTopicChartData" />
                        </div>
                    </div>
                </div>
                <div class="title__sub mg_top_72">
                    ⦁ 사고 유형별 강약점
                    <Help class="question-mark">
                        <div class="mg_left_20">
                            <ul class="mark__list">
                                <li style="list-style: disc">사실적독해 : 글에 표면적으로 드러난 정보를 파악하여 글의 내용을 체계적으로 이해하는 능력</li>
                                <li style="list-style: disc">추론적독해 : 생략된 정보를 추론하고, 글에 드러난 단서를 근거로 글쓴이의 의도나 목적을 추측하는 능력</li>
                                <li style="list-style: disc">비판적독해 : 글에 사용된 자료가 정확한지, 글쓴이의 주장이나 의견이 타당한지 점검하며 글을 읽는 능력</li>
                                <li style="list-style: disc">감상적독해 : 글에서 공감하거나 감동적인 부분을 읽고 글에 담긴 가치를 종합적으로 이해하는 능력</li>
                                <li style="list-style: disc">개념 : 개념을 적용하여 글을 이해하고 판단하는 능력</li>
                                <li style="list-style: disc">어휘 : 글에 나온 어휘의 의미를 알고 문맥에 맞게 사용하며 적용할 수 있는 능력</li>
                            </ul>
                        </div>
                    </Help>
                </div>
                <div style="padding: 1vmin 1.8vw; font-size: 2.3vmin; line-height: 4.16vmin; white-space: pre-line">
                    <p class="evalReportText20">{{ comments?.commentAnalysis }}</p>
                </div>
                <div class="colum__chart__wrap">
                    <!-- <div class="answer__box">
                        <div class="answer__box__wrap">
                            <div class="answer__box__legend"></div>
                            <div class="medium">내 정답률</div>
                        </div>
                    </div> -->
                    <columChart v-if="analysisChartData.length > 0" :chartData="analysisChartData" />
                </div>

                <div class="title__sub mg_top_72">⦁ 질문 유형별 강약점</div>
                <div class="final__comment mg_bottom_40" style="padding: 1vmin 1.8vw; margin: 0px">
                    <p class="evalReportText20">{{ comments?.commentProblemType }}</p>
                </div>
                <div class="colum__chart__wrap">
                    <!-- <div class="answer__box">
                        <div class="answer__box__wrap">
                            <div class="answer__box__legend"></div>
                            <div class="medium">내 정답률</div>
                        </div>
                    </div> -->
                    <columChart v-if="problemTypeChartData.length > 0" :chartData="problemTypeChartData" />
                </div>
                <div class="title mg_top_92" style="margin-top: 11.67vmin">문항별 풀이 결과</div>
                <div class="title__sub mg_bottom_40">⦁ 문학</div>
                <q-markup-table flat class="summary-table">
                    <thead>
                        <tr>
                            <th class="text-center">번호</th>
                            <th class="text-center">갈래/주제 및 지문</th>
                            <th class="text-center">KReaD</th>
                            <th class="text-center">풀이/목표시간</th>
                            <th class="text-center">사고 유형</th>
                            <th class="text-center">학습 개념 상세</th>
                            <th class="text-center">정답여부</th>
                            <th class="text-center">풀이화면</th>
                        </tr>
                    </thead>
                    <tbody v-if="problemList">
                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListL)">
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ index + 1 }} - {{ index + 3 }}</td>
                            <td class="" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1" style="width: calc(100% - 660px)">
                                <!-- <div style="width: calc( 100vw - 750px);text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                [{{ vData?.topic }}] {{ vData?.passageName }}
                                <!-- </div> -->
                            </td>
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ vData?.kreadScore }}</td>
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                <span :style="vData?.elapsedTime > vData?.solveTime ? 'color:#EF2B2A' : ''">
                                    {{ getTimeStringSecondsKor(vData?.elapsedTime) }}
                                </span>
                                /<br />{{ getTimeStringSecondsKor(vData?.solveTime) }}
                            </td>
                            <td class="text-center">{{ vData?.analysisName }}</td>
                            <td class="text-center">
                                <!-- <div style="width: 200px;text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                {{ vData?.learningConceptName }}
                                <!-- </div> -->
                            </td>
                            <td class="text-center">
                                <q-icon :name="vData.correctYn === 1 ? 'img:/assets/images/icon/ic_ox_1.svg' : 'img:/assets/images/icon/ic_ox_3.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                                <!-- <q-icon :name="vData.correctYn === 1 ? 'radio_button_unchecked' : 'close'" size="sm" :style="vData.correctYn === 0 ? 'color:#EF2B2A ;' : ''"> </q-icon> -->
                            </td>
                            <td
                                class="text-center"
                                style="cursor: pointer"
                                :onClick="
                                    () => {
                                        onClickReview(vData?.diagnosticAnswerHistorySeq, index + 1);
                                    }
                                "
                            >
                                <u>보기</u>
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
                <div class="title__sub mg_top_80 mg_bottom_40">⦁ 비문학</div>
                <q-markup-table flat class="summary-table">
                    <thead>
                        <tr>
                            <th class="text-center">번호</th>
                            <th class="text-center">갈래/주제 및 지문</th>
                            <th class="text-center">KReaD</th>
                            <th class="text-center">풀이/목표시간</th>
                            <th class="text-center">사고 유형</th>
                            <th class="text-center">학습 개념 상세</th>
                            <th class="text-center">정답여부</th>
                            <th class="text-center">풀이화면</th>
                        </tr>
                    </thead>
                    <tbody v-if="problemList">
                        <tr v-for="(vData, index) in Object.values(problemList?.problemResultListN)">
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ index + 1 + 15 }} - {{ index + 3 + 15 }}</td>
                            <td class="" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1" style="width: calc(100% - 660px)">
                                <!-- <div style="width: calc( 100vw - 750px);text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                [{{ vData?.topic }}] {{ vData?.passageName }}
                                <!-- </div> -->
                            </td>
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">{{ vData?.kreadScore }}</td>
                            <td class="text-center" v-if="index % 3 === 0" :rowspan="index % 3 === 0 ? 3 : 1">
                                <span :style="vData?.elapsedTime > vData?.solveTime ? 'color:#EF2B2A' : ''">
                                    {{ getTimeStringSecondsKor(vData?.elapsedTime) }}
                                </span>
                                /<br />{{ getTimeStringSecondsKor(vData?.solveTime) }}
                            </td>
                            <td class="text-center">{{ vData?.analysisName }}</td>
                            <td class="text-center">
                                <!-- <div style="width: 200px;text-overflow: ellipsis !important;white-space: nowrap !important;overflow: hidden !important;"> -->
                                {{ vData?.learningConceptName }}
                                <!-- </div> -->
                            </td>
                            <td class="text-center">
                                <q-icon :name="vData.correctYn === 1 ? 'img:/assets/images/icon/ic_ox_1.svg' : 'img:/assets/images/icon/ic_ox_3.svg'" style="width: 2vw; height: 2vw"> </q-icon>
                                <!-- <q-icon :name="vData.correctYn === 1 ? 'radio_button_unchecked' : 'close'" size="sm" :style="vData.correctYn === 0 ? 'color:#EF2B2A ;' : ''"> </q-icon> -->
                            </td>
                            <td
                                class="text-center"
                                style="cursor: pointer"
                                :onClick="
                                    () => {
                                        onClickReview(vData?.diagnosticAnswerHistorySeq, index + 16);
                                    }
                                "
                            >
                                <u>보기</u>
                            </td>
                        </tr>
                    </tbody>
                </q-markup-table>
            </div>
            <div class="mg_top_48 mg_bottom_72 btn__wrap" style="text-align: center">
                <template v-if="!isListItem">
                    <template v-if="globalStore.loginRoot === 'growthplate'">
                        <CqBtn class="btn" outline color="" label="다음 과목 선택" style="margin-left: 10px" @onClickFn="moveToGrowthplate('end')" />
                    </template>
                    <CqBtn class="btn" outline color="" label="다음 학습" @onClickFn="studyStart" style="margin-right: 10px" />
                    <CqBtn class="btn" outline color="" label="학습 홈" @onClickFn="movePage('learninghome')" style="margin-left: 10px" />
                    <template v-if="globalStore.loginRoot === 'growthplate'">
                        <CqBtn class="btn" outline color="" label="오늘 학습 종료" style="margin-left: 10px" @onClickFn="moveToGrowthplate('selfcheck')" />
                    </template>

                    <!-- <CusButton v-if="props.reportData" :type="550" :label="`진단평가완료`" @onReturn="movePg()" /> -->
                    <!-- <CqBtn class="btn" v-if="props.reportData" unelevated color="black" label="진단평가완료" @onClickFn="movePg()" /> -->
                </template>
                <template v-if="isListItem">
                    <CusButton
                        :type="462"
                        :label="`분석리포트 홈`"
                        @onReturn="
                            () => {
                                emit('close');
                            }
                        "
                    />

                    <!-- <CqBtn
                        class="btn"
                        outline
                        color=""
                        label="분석리포트 홈"
                        @onClickFn="
                            () => {
                                emit('close');
                            }
                        "
                    /> -->
                </template>
            </div>
        </q-scroll-area>
    </div>
    <q-dialog v-model="reviewModal" persistent maximized>
        <!-- transition-show="slide-left" transition-hide="slide-right"
  > -->
        <Review v-if="reviewModal" :answerHistorySeq="answerHistorySeq" type="diagnostic" :num="answerNum"></Review>
    </q-dialog>
    <!-- <template class="print_area">
    <PrintDiagnosticReportContent v-if="props.reportData" :reportData="props.reportData" />
  </template> -->
</template>

<script setup>
import CusButton from '@/components/widget/CusButton.vue';
import StudyHeader from '@/components/layouts/header/studyHeader.vue';
import GaugeChart from '@/components/chart/gaugeChart.vue';
import { onMounted, ref, watch, computed } from 'vue';
import { getUserJson, postUserJson, growthplateFinishDignostic, getUserMain2 } from '@/api/modules/login';
import { GlobalStore } from '@/store';
import _ from 'lodash';
import { getReportDiagnostic, getReportReview } from '@/api/modules/study';
import { StudyStore } from '@/store/modules/study';
import { getTimeStringSecondsKor, getKreadGrade } from '@/helpers/utils';
import { useRouter } from 'vue-router';
import CqBtn from '@/components/quasar/cqBtn.vue';
import { analysis, difficult, problemType } from '@/helpers/qbankParser/qbankMeta';
import moment from 'moment';
import { useQuasar } from 'quasar';
import Help from '@/components/quasar/help.vue';
import Review from '../component/review.vue';
import { testData } from './test';
import columChart from '@/components/chart/columChart.vue';
import { DialogStore } from '@/store/modules/dialog';
import RadarChart from '@/components/chart/radarChart.vue';
import LessonChart from '@/components/chart/lessonChart.vue';
import LevelLineChart from '@/components/chart/levelLineChart.vue';
import KreadChart from '@/components/chart/kreadChart.vue';
import Comm from '@/components/common.js';
// import { requestGrowthplateLogout } from '@/helpers/common';
// data.data.diagnosticInfo.schoolGrade
const isLog = true;
// import { GlobalStore } from '@/store';
const gStore = GlobalStore();

const comUserName = computed(() => {
    return Comm.getStrName();
});
const comSchoolAndGrade = computed(() => {
    return Comm.getDiagnosticSchoolAndGrade();
});
// const isMember = gStore.is_member_eval;
// const nonMemberSchoolGrade = computed(() => {
//     if (gStore.evalData.first_kread === 'M2') return '중학교 2학년';
//     if (gStore.evalData.first_kread === 'M3') return '중학교 3학년';
//     return '중학교 1학년';
// });
// const getStringUserGrade = computed(() => {
//     return Comm.getHakNyoun(gStore.userInfo.grade);
// });

const $q = useQuasar();
const coreProcess = ref(0.5);
const model = ref('1');
const user = ref(null);
const reviewModal = ref(false);
const answerHistorySeq = ref(null);
let answerNum = null;
const tab = ref('passage1');
const globalStore = GlobalStore();
const studyStore = StudyStore();
const summaryData = ref(null);
const comments = ref(null);
const passageList = ref(null);
const problemList = ref(null);
const analysisResult = ref({});
const analysisChartData = ref([]);
const problemTypeChartData = ref([]);
const lTopicChartData = ref(null);
const nTopicChartData = ref(null);
const router = useRouter();
const store = DialogStore();

const growthData = ref({
    systemId: '',
    sbjgrpId: '',
    sbjgrpSeq: '',
    kunnr: '',
    loginSeq: '',
    scenarioSeq: '',
    accessToken: '',
    scenarioLvlSeq: '',
    ustudyActSeq: '',
    zempId: '',
    matnrSeq: '',
    matnr: '',
    zProc: '',
    setNo: '',
});

const props = defineProps({
    // 'reportParams': {
    //   default: null
    //   // default: {
    //   //   areaCode: "02",
    //   //   learningHistorySeq: 2338,
    //   //   learningTypeCode: 1,
    //   //   lesson: 1,
    //   // }
    // },
    reportData: {
        default: null,
        // default: {
        //   areaCode: "02",
        //   learningHistorySeq: 2338,
        //   learningTypeCode: 1,
        //   lesson: 1,
        // }
    },
    isListItem: { default: false },
    diagnosticSeq: {
        default: null,
    },
});

const emit = defineEmits(['close']);

const onClickReview = (seq, num) => {
    //console.log(seq);
    //console.log(num);
    answerHistorySeq.value = seq;
    answerNum = num;
    reviewModal.value = true;
    // getReportReview({ answerHistorySeq: seq }, (rs) => {
    //   if(isLog) console.log(rs);
    // })
};

const setData = (rs) => {
    // console.log('--setData-rs-', rs);
    // console.log('--setData-rs schoolGrade-', rs.diagnosticInfo.schoolGrade);
    // const rs = testData;

    gStore.setEvalRealGrade(rs.diagnosticInfo.schoolGrade); // 비회원 실제학년정보 수정.

    summaryData.value = rs.diagnosticInfo;
    // passageList.value = { passageResultListL: rs.passageResultListL, passageResultListN: rs.passageResultListN, };
    let tmpLiteratureResult = [];
    rs.literatureResult.forEach((item) => {
        item.problemResultList.forEach((i) => {
            tmpLiteratureResult.push({ ...i, elapsedTime: item.elapsedTime, kreadScore: item.kreadScore, passageName: item.passageName, passageSeq: item.passageSeq, solveTime: item.solveTime, topic: item.topic });
        });
    });
    let tmpNonLiteratureResult = [];
    rs.nonLiteratureResult.forEach((item) => {
        item.problemResultList.forEach((i) => {
            tmpNonLiteratureResult.push({ ...i, elapsedTime: item.elapsedTime, kreadScore: item.kreadScore, passageName: item.passageName, passageSeq: item.passageSeq, solveTime: item.solveTime, topic: item.topic });
        });
    });

    // 첫 3지문 크리드점수 지우기
    const REtmpLiteratureResult = tmpLiteratureResult.map((e, i) => {
        return i < 9 ? { ...e, kreadScore: '-' } : e;
    });
    problemList.value = { problemResultListL: REtmpLiteratureResult, problemResultListN: tmpNonLiteratureResult };
    //    console.log('----REtmpLiteratureResult---- ', REtmpLiteratureResult);
    let tmpChartData = [];
    comments.value = {
        commentAnalysis: rs.commentAnalysis,
        commentDiagnosticResult: rs.commentDiagnosticResult,
        commentMyKread: rs.commentMyKread,
        commentProblemType: rs.commentProblemType,
        commentStartPoint: rs.commentStartPoint,
        commentTopic: rs.commentTopic,
    };
    Object.entries(analysis).forEach(([k, v]) => {
        if (rs.analysisResult['analysis' + k] > -1) {
            if (v.ord < 4) {
                tmpChartData.push({
                    category: v.label + ' 독해',
                    value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                    ord: v.ord,
                });
            } else {
                tmpChartData.push({
                    category: v.label,
                    value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
                    ord: v.ord,
                });
            }
        }
    });
    // Object.entries(analysis).forEach(([k, v]) => {
    //   if (v.ord < 4) {
    //     tmpChartData.push({
    //       category: v.label + " 독해",
    //       value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
    //     })
    //   } else {
    //     tmpChartData.push({
    //       category: v.label,
    //       value1: rs.analysisResult['analysis' + k] < 0 ? 0 : rs.analysisResult['analysis' + k],
    //     })
    //   }
    // })
    const topicType = {
        passage01: '현대시',
        passage02: '고전시가',
        passage03: '고전산문',
        passage04: '현대소설',
        passage05: '극·수필',
        passage06: '인문',
        passage07: '예술',
        passage08: '정치·사회',
        passage09: '경제·문화',
        passage10: '과학',
        passage11: '기술',
        passage12: '융합',
    };
    let tmpLTopic = [];
    let tmpNTopic = [];
    Object.keys(rs.topicResult).forEach((k, i) => {
        if (i < 5) {
            tmpLTopic.push({ name: topicType[k], value: rs.topicResult[k] });
        } else {
            tmpNTopic.push({ name: topicType[k], value: rs.topicResult[k] });
        }
    });
    lTopicChartData.value = tmpLTopic;
    nTopicChartData.value = tmpNTopic;
    //console.log(tmpLTopic)
    //console.log(tmpNTopic)
    // Object.entries(testData.analysisResult).forEach(([k, v]) => {

    //   const tmpKey = k.replace('analysis', '');
    //   if (analysis[tmpKey].ord < 4) {
    //     tmpChartData.push({
    //       category: analysis[tmpKey].label + " 독해",
    //       value1: v,
    //     })
    //   } else {
    //     tmpChartData.push({
    //       category: analysis[tmpKey].label,
    //       value1: v,
    //     })
    //   }
    // });
    analysisChartData.value = _.sortBy(tmpChartData, 'ord');
    //console.log(analysisChartData);
    let tmpProblemTypeChartData = [];
    Object.entries(problemType).forEach(([k, v]) => {
        tmpProblemTypeChartData.push({
            category: v,
            value1: rs.problemTypeResult[k] < 0 ? 0 : rs.problemTypeResult[k],
        });
    });
    problemTypeChartData.value = tmpProblemTypeChartData;
    //console.log(_.isEmpty(globalStore.userInfo));
    // if (_.isEmpty(globalStore.userInfo)) {
    // globalStore.getUserInfo();
    //console.log(globalStore.getUserInfo());
    // }
    user.value = globalStore.userInfo;
};

const studyStart = async () => {
    const res = await getUserMain2();
    if (res && res.status === 200) {
        const rs = res.data.data;
        let tmpMapTree = [];
        rs.studyMain.forEach((element) => {
            tmpMapTree.push({
                examCode: element.examName,
                version: rs.exprVersion,
                headerEtcCd02: element.areaCode === '01' ? '05' : '02',
                headerEtcCd01: element.passageClass,
                passageClass: element.passageClass,
                area: element.areaCode === '01' ? '문학' : '비문학',
                title: element.passageName,
                areaCode: element.areaCode,
                isDone: false,
                learningStatus: element.learningStatus,
                learningType: element.learningType,
                difficult: element.areaCode === '01' ? JSON.parse(element.difficultyL) : JSON.parse(element.difficultyN),
                satOrder: element?.satOrder ? element?.satOrder : null,
                groupIndex: element?.groupIndex ? element?.groupIndex : null,
                level: element?.level,
                lesson: element?.lesson,
            });
        });
        studyStore.level = rs.level;
        studyStore.lesson = rs.lesson;
        studyStore.exprVersion = rs.exprVersion;
        studyStore.mapTree.exams = tmpMapTree;

        const fIndex = _.findIndex(rs.studyMain, function (o) {
            return o.examName === rs.currentStart.examName;
        });
        studyStore.process.examIdx = fIndex;
        if (rs.studyMain[fIndex].learningStatus === 'W') {
            studyStore.process.studyTree = 5082;
        }
        studyStore.process.problemOrd = 0;
        studyStore.process.exam = {
            examCode: rs.currentStart.examName,
            version: rs.exprVersion,
            headerEtcCd02: rs.currentStart.areaCode === '01' ? '05' : '02',
            headerEtcCd01: rs.studyMain[fIndex].headerEtcCd01,
            passageClass: rs.studyMain[fIndex].passageClass,
            area: rs.currentStart.areaCode === '01' ? '문학' : '비문학',
            title: rs.studyMain[fIndex].passageName,
            areaCode: rs.currentStart.areaCode,
            isDone: false,
            learningHistorySeq: rs.currentStart.learningHistorySeq,
            learningType: rs.currentStart.learningType,
            learningStatus: rs.studyMain[fIndex]?.learningStatus,
            difficult: rs.currentStart.areaCode === '01' ? JSON.parse(rs.studyMain[fIndex]?.difficultyL) : JSON.parse(rs.studyMain[fIndex]?.difficultyN),
            satOrder: rs.currentStart?.satOrder ? rs.currentStart?.satOrder : null,
            groupIndex: rs.currentStart?.groupIndex ? rs.currentStart?.groupIndex : null,
            level: rs.currentStart?.level,
            lesson: rs.currentStart?.lesson,
        };

        if (rs.currentStart.learningType === 'SAT' || rs.currentStart.learningType === 'SAT_RESET') {
            return router.push('/sat');
        } else {
            return router.push('/corereading');
        }
    }
};

const requestGrowthplateFinishDignostic = async () => {
    console.log('studyStore ===', studyStore);
    let params = {
        diagnosticSeq: props.diagnosticSeq,
    };
    console.log('requestGrowthplateFinishDignostic params ===', params);

    const response = await growthplateFinishDignostic(params);
    console.log('growthplateFinishDignostic API response ===', response);
    const resData = response?.data?.data;
    if (response?.data?.statusCode === '200') {
        growthData.value.systemId = resData?.systemId;
        growthData.value.sbjgrpId = resData?.sbjgrpId;
        growthData.value.sbjgrpSeq = resData?.sbjgrpSeq;
        growthData.value.kunnr = resData?.kunnr;
        growthData.value.loginSeq = resData?.loginSeq;
        growthData.value.scenarioSeq = resData?.scenarioSeq;
        growthData.value.accessToken = resData?.accessToken;
        growthData.value.scenarioLvlSeq = resData?.scenarioLvlSeq;
        growthData.value.ustudyActSeq = resData?.ustudyActSeq;
        growthData.value.zempId = resData?.zempId;
        growthData.value.matnrSeq = resData?.matnrSeq;
        growthData.value.matnr = resData?.matnr;
        growthData.value.zProc = resData?.zProc;
        growthData.value.setNo = resData?.setNo;
    }
};

const sendGrowthData = (type) => {
    const globalStore = GlobalStore();
    let dataToSend = {
        systemId: growthData.value.systemId,
        sbjgrpId: growthData.value.sbjgrpId,
        sbjgrpSeq: growthData.value.sbjgrpSeq,
        kunnr: encodeURI(growthData.value.kunnr),
        loginSeq: growthData.value.loginSeq,
        scenarioSeq: growthData.value.scenarioSeq,
        accessToken: encodeURI(growthData.value.accessToken),
        scenarioLvlSeq: growthData.value.scenarioLvlSeq,
        ustudyActSeq: growthData.value.ustudyActSeq,
        zempId: encodeURI(growthData.value.zempId),
        matnrSeq: growthData.value.matnrSeq,
        matnr: growthData.value.matnr,
        zProc: growthData.value.zProc,
        setNo: growthData.value.setNo,
        path: type === 'selfcheck' ? 'Important' : 'Main',
    };
    // const jsonStr = JSON.stringify(dataToSend);
    // console.log('jsonStr ===', jsonStr);
    //Growth.sendDataToAndroid(jsonStr);
    window.PanApp.sendErrToAndroid('Home');

    globalStore.setToken(null);
    globalStore.setReToken(null);
    globalStore.setAudience('');
    globalStore.setLogoutPath('');
};

const moveToGrowthplate = (type) => {
    console.log('moveToGrowthplate type', type);
    sendGrowthData(type);
};

onMounted(() => {
    // summaryData.value = {
    //   totalAccuracyRate: testData.totalAccuracyRate,
    //   coreResult: testData.totalLearningResult.coreResult,
    //   earnestResult: testData.totalLearningResult.earnestResult,
    //   vocabularyResult: testData.totalLearningResult.vocabularyResult,
    // }
    // passageList.value = testData.passageList
    // getReportSat({ learningHistorySeq: 760 }, (rs) => {
    // if (props?.reportParams) {
    //   if (props.reportParams.diagnosticSeq) {
    //     // getReportDiagnostic({ diagnosticSeq: props.reportParams.diagnosticSeq }, (rs) => {
    //     getReportDiagnostic({ diagnosticSeq: props.reportParams.diagnosticSeq }, (rs) => {
    //       // const rs = testData.data
    //       if(isLog) console.log('--getReportDiagnostic-res-', rs)
    //       setData(rs);
    //     })
    //   }
    // }
    if (props?.reportData) {
        setData(props?.reportData);
    }

    // if (!props.isListItem && globalStore.loginRoot === 'growthplate') {
    //     requestGrowthplateFinishDignostic();
    // }
});

const movePage = (type) => {
    if (type === 'learninghome') {
        router.push('/learninghome');
    }
};

// const movePg = () => {
//     gStore.is_member_eval ? router.push('/learninghome') : router.push('/eval-login');
// };

const checkConfirm = (val) => {
    val && router.push('/learninghome');
};

const onClickHome = () => {
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
};
</script>

<style scoped lang="scss">
.report {
    width: 100%;
    height: calc(100vh - 7.3vmin);

    &__title {
        font-size: 2.2vw;
        line-height: 3.3vw;
        font-weight: bold;
    }

    &__calendar {
        margin-top: 2.67vmin;
        // display: flex;
        line-height: 2.1vw;
        font-size: 1.3vw;
        align-items: center;
        color: $color_gray_600;
    }

    .top__info {
        // padding: 6.67vmin 19.17vmin;
        padding: 6.67vmin 10.17vmin;

        &__wrap {
            display: flex;
            justify-content: space-between;
        }
    }

    .chart__wrap {
        display: inline-flex;
        justify-content: center;
        // align-items: center;
        width: 56.75vmin;
        height: 31.83vmin;
        background-color: white;
        // border-radius: 2.67vmin;
        @include border-radius(1.6vw);

        .chart__item {
            display: flex;
        }

        .chart__area {
            width: 25.58vmin;
            height: 12.75vmin;
            margin-top: 5.5vmin;
        }
    }

    .chart__summary {
        display: inline-flex;
        align-items: center;
        color: $text_secondary;
        margin-left: 5.23vmin;
    }

    .hr {
        margin-top: 5vmin;
        border: 10px solid $color_gray_100;
    }

    .kread {
        display: inline-flex;
        background-color: #efefef;
        font-size: 1.1vw;
        align-items: center;
        border-radius: 60px;
        padding: 0 2.66vmin;
        height: 6.67vmin;
        margin-left: 1.33vmin;

        img {
            height: 2vmin;
            margin-right: 8px;
        }

        .score {
            background-color: $primary;
            padding: 0.17vmin 0.83vmin;
            border-radius: 50%;
            color: white;
            font-weight: 700;
        }
    }
}

.pd_lr_230 {
    // padding-left: 19.17vmin;
    // padding-right: 19.17vmin;
    padding-left: 10.17vmin;
    padding-right: 10.17vmin;
}

.pd__10 {
    padding: 0.83vmin !important;
}

.mg_top_46 {
    margin-top: 3.83vmin;
}

.mg_top_58 {
    margin-top: 4.83vmin;
}

.mg_top_72 {
    margin-top: 6vmin;
}

.mg_top_80 {
    margin-top: 6.67vmin;
}

.mg_top_92 {
    margin-top: 7.67vmin;
}

.mg_bottom_72 {
    margin-bottom: 6vmin;
}

.final__comment {
    // padding: 1.67vmin;
    font-size: 1.4vw;
    line-height: 2.5vw;
    white-space: pre-line;
    margin-top: 2.2vmin;
    // margin-bottom: 6.67vmin;
}

.sub-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 3.33vmin;
}

.title {
    font-size: 1.8vw;
    line-height: 2.6vw;
    font-weight: 700;
    margin-top: 1vmin;
    margin-bottom: 2vmin;
}

.summary_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc((100% / 3) - 1.67vmin);
    // width: 41.67vmin;
    height: 15.5vmin;
    padding: 3.33vmin;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    @include border-radius(0.8vw);
    background-color: #f7f7f7;
}

.summary-table {
    border-top: 1px solid #8e8e8e;
    border-bottom: 1px solid #8e8e8e;
    border-radius: 0px;

    thead {
        background-color: #ededed;
    }
}

.item-box {
    // display: flex;
    // border: 1px solid #E0E0E0;
    // border-radius: 10px;
    padding: 20px;
    font-size: 2vmin;
}

.q-table {
    font-size: 2vmin;

    th {
        background-color: $color_gray_100;
        font-size: 1.2vw;
        // padding: 2.3vmin 0 2vmin;
        height: 6.67vmin;
        max-width: 200px;
    }

    td {
        font-size: 1.3vw;
        line-height: 2.1vw;
        font-weight: 400;
        height: 8.5vmin;
        max-width: 200px;
        /* overflow: hidden;
        text-overflow: ellipsis; */
        white-space: normal;
    }
}

.btn {
    flex: 1;
    height: 8.17vmin;
    margin: 0 1vw;
    font-size: 1.2vw;
    font-weight: 700;
    border-radius: 1.33vmin;
    &__wrap {
        display: flex;
        padding: 0 5vw;
        justify-content: center;
    }
}

::v-deep {
    .q-btn__content {
        .block {
            font-weight: 700;
        }
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.title__sub {
    // margin: 3.33vmin 0;
    font-size: 1.6vw;
    font-weight: 500;
}

.help__content {
    font-weight: 500;
    font-size: 1.1vw;
    line-height: 1.85vw;
    margin-left: 1.33vmin;
}

.colum__chart__wrap {
    height: 50vmin;
    width: 100%;
    padding: 1.67vmin;
    background-color: $color_gray_100;

    .answer__box {
        width: 100%;
        display: grid;
        justify-items: end;
        font-weight: 500;

        &__wrap {
            display: inline-flex;
            align-items: center;
        }

        &__legend {
            width: 3.33vmin;
            height: 1.17vmin;
            background-color: #18b73f;
            margin-right: 0.83vmin;
            border-bottom-right-radius: 50px;
            border-top-right-radius: 50px;
        }
    }
}

.kread_area {
    background-color: $color_gray_100;
    padding: 1.5vmin 7.5vmin 4.33vmin 6.83vmin;
    margin-bottom: 9.58vmin;
}

.start_title {
    display: inline-flex;
    justify-content: space-between;
    width: 100%;

    .level {
        display: inline-flex;
        background-color: #efefef;
        font-size: 1.2vw;
        align-items: center;
        border-radius: 60px;
        padding: 0 2.67vmin;
        height: 6.67vmin;
        font-weight: 700;
        color: #222;
    }
}

.start_area {
    padding: 6.08vmin 4.42vmin 3.83vmin 6.83vmin;
    background-color: $color_gray_100;
    margin-bottom: 11.67vmin;
}

.radar {
    width: 100%;
    display: inline-flex;
    justify-content: space-between;

    &__box {
        width: calc(50% - 10px);

        &__top {
            width: 100%;
            padding: 1.9vmin 0;
            @include border-radius(0.4vw);
            background-color: #ededed;
            font-size: 1.4vw;
            font-weight: 700;
            text-align: center;
        }

        &__content {
            width: 100%;
            background-color: #fafafa;
            height: 35.08vmin;
            padding: 1vmin;
        }
    }
}

.question-mark {
    width: 2.1vw;
    height: 1.7vw;
    font-size: 1.5vw !important;
    align-items: flex-start;
}

.mark__list {
    li {
        font-size: 1.1vw;
        font-weight: 500;
        line-height: 1.85vw;

        &:nth-of-type(n + 2) {
            margin-top: 0.67vmin;
        }
    }
}

.mark__list {
    li {
        font-size: 1.1vw;
        font-weight: 500;
        line-height: 1.85vw;
        word-break: keep-all;

        &:nth-of-type(n + 2) {
            margin-top: 0.67vmin;
        }
    }
}
.align-center {
    align-items: center;
}
</style>
